import { createQueryData } from '../helpers/createQueryData';

const { useQuery: useAddressTypesQuery } = createQueryData({
  endPoint: 'Acceptance/get_addresses_types',
  options: {
    errorMessage: 'Не удалось получить типы помещений',
  },
});

export { useAddressTypesQuery };
